import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {toasterActions} from '@homeaway/react-toaster';
import {LOADING_ANIMATION} from '../../constants';
import TripBoard from '../TripBoard/TripBoard';
import './TripBoardButton.less';
import {setTripboardTranslations} from '../../actions/index';
import HeartIcon from '../HeartIcon/HeartIcon';

class TripBoardButton extends Component {
    static propTypes = {
        adultsCount: PropTypes.number,
        childrenCount: PropTypes.number,
        endDate: PropTypes.string,
        isDisabled: PropTypes.bool,
        isHearted: PropTypes.bool,
        isLoading: PropTypes.bool,
        listingId: PropTypes.string.isRequired,
        tripBoards: PropTypes.object, // eslint-disable-line react/forbid-prop-types
        getTripboards: PropTypes.func,
        onHeart: PropTypes.func,
        onUnheart: PropTypes.func,
        petIncluded: PropTypes.bool,
        position: PropTypes.oneOf(['bottom', 'left', 'right', 'right-auto']),
        siteName: PropTypes.string,
        startDate: PropTypes.string,
        thumbnailUrl: PropTypes.string,
        type: PropTypes.oneOf(['default', 'outline']),
        rating: PropTypes.number,
        headline: PropTypes.string,
        reviewCount: PropTypes.number,
        abacus: PropTypes.object, // eslint-disable-line
        useNativeEventListener: PropTypes.bool
    };

    static defaultProps = {
        adultsCount: null,
        childrenCount: null,
        isDisabled: false,
        isHearted: false,
        isLoading: true,
        onHeart: () => {},
        onUnheart: () => {},
        tripBoards: {boards: []},
        getTripboards: () => {},
        petIncluded: null,
        position: 'right',
        siteName: null,
        thumbnailUrl: null,
        type: 'default',
        rating: 0,
        headline: '',
        reviewCount: 0,
        abacus: {},
        useNativeEventListener: false
    };

    constructor(props) {
        super(props);
        const {abacus} = props;
        this.refButton = null;
        this.stabHit = null;

        // heart loading animations test
        this.loadingAnimTestValue = abacus[LOADING_ANIMATION] ? abacus[LOADING_ANIMATION].value : 0;
        this.isAbacusLoadingTestOn = this.loadingAnimTestValue > 0;
    }

    componentDidMount() {
        const props = this.props;
        const {siteName, createToast, getTripboards} = props;

        this.setUpTripBoard(siteName, createToast, getTripboards);
        if (
            typeof window !== 'undefined' &&
            Object.keys(this.props.translations).length === 0 &&
            window.tripboardConfig &&
            window.tripboardConfig.translations
        ) {
            this.props.setTripboardTranslations({translations: window.tripboardConfig.translations});
        }
        if (typeof window !== 'undefined' && typeof window.__ABACUS__ !== 'undefined') {
            TripBoard.testExposure.loadingAnimation.trigger();
        }

        if (this.props.useNativeEventListener && this.refButton) {
            this.refButton.addEventListener('click', this.toggle);
        }
    }

    componentWillUnmount() {
        if (this.props.useNativeEventListener && this.refButton) {
            this.refButton.removeEventListener('click', this.toggle);
        }
    }

    setUpTripBoard(siteName, createToast, getTripboards) {
        TripBoard.setSitename(siteName);
        TripBoard.setCreateToast(createToast);
        TripBoard.setGetTripboards(getTripboards);
        TripBoard.setVisibilityListener();
    }

    toggle = () => {
        if (this.props.isHearted) {
            TripBoard.remove(this.props.removeFromBoard, this.props.listingId, this.props.tripboards.boards);
        } else {
            TripBoard.open(this);
        }
    };

    render() {
        const {isDisabled, position, type, tripboards, translations, loading} = this.props;
        const boards = (tripboards && tripboards.boards) || [];
        const translationKey =
            !loading && boards.length > 0 ? 'tripboards.modal.add.to' : 'tripboards.modal.create.new.list.copy';
        const ariaLabel = translations[translationKey];

        const buttonClasses = classnames({
            'react-trip-board-button': true,
            'react-trip-board-button__position-bottom': position === 'bottom',
            'react-trip-board-button__position-right': position === 'right',
            'react-trip-board-button__outline': type === 'outline'
        });

        const iconClass = classnames('react-trip-board-button__heart-core__heart-icon', {
            unhearted: !this.props.isHearted,
            isDisabled,
            'loading-anim-1': loading && this.loadingAnimTestValue === 1,
            'loading-anim-2': loading && this.loadingAnimTestValue === 2
        });

        const iconClassBg = classnames('react-trip-board-button__heart-core__heart-icon', {
            unhearted: !this.props.isHearted,
            'loading-anim-bg-1': loading && this.loadingAnimTestValue === 1,
            'loading-anim-bg-2': loading && this.loadingAnimTestValue === 2
        });

        return (
            <button
                aria-label={ariaLabel}
                className={buttonClasses}
                disabled={isDisabled}
                onClick={this.toggle}
                tabIndex="-1"
                ref={(c) => (this.refButton = c)}
            >
                <HeartIcon
                    iconClass={iconClass}
                    iconClassBg={iconClassBg}
                    isAbacusLoadingTestOn={this.isAbacusLoadingTestOn}
                />
            </button>
        );
    }
}

const mapStateToProps = (state, props) => {
    const {translations} = state.tripboardButton;
    const boards = (props.tripboards && props.tripboards.boards) || [];
    let isHearted = false;
    for (let index = 0; index < boards.length; index++) {
        const tripboard = boards[index];
        const listingRefs = tripboard.listingRefs || [];
        if (listingRefs.includes(props.listingId)) {
            isHearted = true;
            break;
        }
    }

    return {
        isHearted,
        translations
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            createToast: toasterActions.createToast,
            setTripboardTranslations
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(TripBoardButton);
